import { render } from "./AppSkeletonTable.vue?vue&type=template&id=a32c0958"
import script from "./AppSkeletonTable.vue?vue&type=script&lang=js"
export * from "./AppSkeletonTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__